import { Injectable } from '@angular/core';

import { ApiService, AppContext, LogService, BillingService } from './../../shared';

@Injectable()
export class UpdateCardService {
  show: boolean = false;

  lastFour: string = '';
  exp: string = '';

  showEditCard: boolean = false;
  card: string = '';
  name: string = '';
  expiration: string = '';
  month: number = -1;
  year: number = -1;
  cvc: string = '';
  postalCode: string = '';

  loaderOn: boolean = false;

  stripeStatus: number = 0;
  stripeResponse: any = null;
  errors = {
    name: '',
    card: '',
    expiration: '',
    cvc: '',
    postalCode: '',
    update: ''
  };

  updateCardAttempted: boolean = false;

  cardOkay: boolean = false;

  constructor(private api: ApiService, private app: AppContext, private logger: LogService, private billing: BillingService) {
    this.init();
  }

  init() {
    this.getCustomer();
    
    this.updateCardAttempted = false;
  }

  toggleEditCard() {
    this.errors.update = '';
    this.showEditCard = !this.showEditCard;
  }

  getCustomer() {
    this.billing.getCustomer().then(customer => {
      this.logger.log('update-card.service', 'getCustomer customer', customer);
      try {
        this.lastFour = customer.sources[0].lastFour;
        this.exp = `${customer.sources[0].expMonth}/${customer.sources[0].expYear}`;
      } catch (ex) {
        this.lastFour = '';
        this.exp = '';
      }
    }).catch(err => {
      this.logger.log('update-card.service', 'getCustomer error', err);
    });
  }

  validateName(): boolean {
    let name = this.name.trim();
    if (name.length === 0 || name.length > 256) {
      return false;
    }
    this.errors.name = '';
    return true;
  }

  validateNameError() {
    let name = this.name.trim();
    if (name.length === 0 || name.length > 256) {
      this.errors.name = 'Card Holder\'s Name Invalid';
    }
  }

  validatePostalCode(): boolean {
    let code = this.postalCode.trim();
    if (code.length === 0 || code.length > 256) {
      return false;
    }
    this.errors.postalCode = '';
    return true;
  }

  validatePostalCodeError() {
    let code = this.postalCode.trim();
    if (code.length === 0 || code.length > 256) {
      this.errors.postalCode = 'Postal Code Invalid';
    }
  }

  validateCard(): boolean {
    this.stripeStatus = 0;

    if (this.card.length !== 13 && this.card.length !== 14 && this.card.length !== 15
      && this.card.length !== 16 && this.card.length !== 17 && this.card.length !== 18
      && this.card.length !== 19) {
      return false;
    }
    this.errors.card = '';
    return true;
  }

  validateCardError() {
    if (this.card.length !== 13 && this.card.length !== 14 && this.card.length !== 15
      && this.card.length !== 16 && this.card.length !== 17 && this.card.length !== 18
      && this.card.length !== 19) {
      this.errors.card = 'Credit Card Number Invalid';
    }
  }

  validateExpiration(): boolean {
    this.stripeStatus = 0;
    try {
      let exp = this.expiration.split('/');
      this.month = +exp[0];
      this.year = +exp[1];

      if (this.month <= 0 || this.month >= 13) {
        return false;
      }

      if (this.year <= 0 || this.year >= 100) {
        return false;
      }
    } catch (ex) {
      return false;
    }
    this.errors.expiration = '';
    return true;
  }

  validateExpirationError(): boolean {
    try {
      let exp = this.expiration.split('/');
      this.month = +exp[0];
      this.year = +exp[1];

      if (this.month <= 0 || this.month >= 13) {
        this.errors.expiration = 'Date Invalid';
        return false;
      }

      if (this.year <= 0 || this.year >= 100) {
        this.errors.expiration = 'Date Invalid';
        return false;
      }
    } catch (ex) {
      this.errors.expiration = 'Date Invalid';
      return false;
    }
    this.errors.expiration = '';
    return true;
  }

  validateCVC(): boolean {
    this.stripeStatus = 0;
    if (this.cvc.length !== 3 && this.cvc.length !== 4) {
      return false;
    }
    this.errors.cvc = '';
    return true;
  }

  validateCVCError() {
    if (this.cvc.length !== 3 && this.cvc.length !== 4) {
      this.errors.cvc = 'CVC Invalid';
    }
  }

  getToken(): Promise<any> {
    let model = {
      name: this.name.trim(),
      number: +this.card,
      exp_month: this.month,
      exp_year: this.year,
      cvc: +this.cvc,
      address_zip: this.postalCode.trim()
    };

    return this.billing.createToken(model);
  }

  tokenResponse(status: number, response: any) {
    this.stripeStatus = status;
    this.stripeResponse = response;
    if (this.stripeStatus === 200) {
      this.cardOkay = true;
    } else {
      this.stripeError(response.error);
      this.cardOkay = false;
    }
  }

  stripeError(error: any) {
    try {
      if (error.param === 'number') {
        this.errors.card = error.message;
      } else if (error.param === 'exp_year' || error.param === 'exp_month') {
        this.errors.expiration = error.message;
      } else if (error.param === 'name') {
        this.errors.name = error.message;
      } else if (error.param === 'address_zip') {
        this.errors.name = error.message;
      }
    } catch (ex) {
      this.errors.update = 'Card Invalid';
    }
  }

  updateCard() {
    this.expirationMasking();
    this.errors.update = '';
    this.loaderOn = true;

    if (this.validateName() && this.validateCard() && this.validateExpiration() && this.validateCVC() && this.validatePostalCode()) {
      this.logger.log('update-card.service', 'getToken', 'before call');
      this.getToken().then((response) => {
        this.tokenResponse(200, response);
        this.callUpdateCard();
      }).catch((err) => {
        this.loaderOn = false;
        this.tokenResponse(400, err);
        this.errors.update = err.message;
      });
      this.updateCardAttempted = true;
    } else {
      // card is not validated, do not create token
      this.cardOkay = false;
      this.loaderOn = false;
      this.errors.update = "Invalid card";
      this.updateCardAttempted = true;
      return;
    }
  }

  callUpdateCard() {
    if (!this.app.isCustomer) {
      this.billing.createCustomer(this.app.email, this.stripeResponse.id)
      .then(customer => {
        this.cardUpdateSuccess(customer);
        this.loaderOn = false;
      }).catch((err) => {
        this.cardUpdateFailure(err);
        this.loaderOn = false;
      });
    } else {
      this.billing.updateCustomer(this.stripeResponse.id)
      .then(customer => {
        this.cardUpdateSuccess(customer);
        this.loaderOn = false;
      }).catch((err) => {
        this.cardUpdateFailure(err);
        this.loaderOn = false;
      });
    }
  }

  cardUpdateSuccess(customer: any) {
    this.app.setIsCustomer('stripeId'); // just to set it to true
    this.app.setCustomer(customer);
    this.getCustomer();
    this.errors.update = 'Success';
    this.showEditCard = false;
  }

  cardUpdateFailure(error: any) {
    this.logger.log('update-card.service', 'cardUpdateFailure', error);
    try {
      this.errors.update = error.data.details.message;
    } catch (ex) {
      this.errors.update = 'Something went wrong';
    }
  }

  validateFrontEnd() {
    this.expirationMasking();
    this.errors.update = '';
    if (this.validateName() && this.validateCard() && this.validateExpiration() && this.validateCVC() && this.validatePostalCode()) {
      this.logger.log('update-card.service', 'getToken', 'before call');
      this.cardOkay = true;
    } else {
      this.cardOkay = false;
    }
  }

  expirationMasking() {
    if (this.expiration.match(/^\d{2}$/) !== null) {
      this.expiration = this.expiration + '/';
    }
  }

  numeralInputMasking(event) {
    let e = event || window.event;
    let key = event.keyCode || e.which;

    if ((key < 48 || key > 57) && key !== 37 && key !== 38
      && key !== 39 && key !== 40 && key !== 46
      && key !==  8 && key !== 35 ) {
      e.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/update-card/update-card.service.ts